<mat-form-field>
	<mat-label>Number Field Type</mat-label>
	<mat-select [(ngModel)]="numberType"
				(ngModelChange)="numberTypeChanged($event)"
				[disabled]="isDisabled">
		<mat-option value="integer">Integer</mat-option>
		<mat-option value="decimal">Decimal</mat-option>
	</mat-select>
</mat-form-field>
<mat-checkbox name="AllowNegativeNumbers" [(ngModel)]="allowNegativeNumbers" (ngModelChange)="negativeNumbersChanged($event)">
	Allow Negative Numbers
</mat-checkbox>